import { Close } from '@mui/icons-material';
import {
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogContentProps,
  DialogProps,
  IconButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
} from '@mui/material';
import { t } from 'i18next';
import { ReactNode } from 'react';

const styleOverrides = {
  '.MuiDialog-paper': {
    borderRadius: '12px',
    py: 1.25,
    'h2.MuiDialogTitle-root': {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      fontSize: '1.5rem',
      fontWeight: '400',
      '.cc-dialog-subtitle': {
        fontSize: '1rem',
        m: 0,
        mt: 0.75,
        color: 'text.secondary',
        fontWeight: '400',
        lineHeight: 1.75,
        letterSpacing: '0.01rem',
      },
      'button.MuiIconButton-root': {
        position: 'relative',
        top: '0',
        right: '0',
      },
    },
  },
};

type ModalProps = Omit<DialogProps, 'sx' | 'onClose' | 'open'> & {
  title: string;
  subtitle?: ReactNode;
  onDismiss: () => void;
};

export const Dialog = ({ children, title, subtitle, maxWidth = 'ms', onDismiss, ...rest }: ModalProps) => {
  const titleContent = subtitle ? (
    <div>
      {title}
      <p className="cc-dialog-subtitle">{subtitle}</p>
    </div>
  ) : (
    title
  );

  return (
    <MuiDialog {...rest} sx={styleOverrides} maxWidth={maxWidth} PaperProps={{ sx: { backgroundColor: 'grey.50' } }} open fullWidth onClose={onDismiss}>
      <MuiDialogTitle>
        {titleContent}
        <IconButton title={t('a11y.dialogs.dialogCloseButton')} onClick={onDismiss} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <Close />
        </IconButton>
      </MuiDialogTitle>
      {children}
    </MuiDialog>
  );
};

export const DialogBody = (props: DialogContentProps) => {
  return <DialogContent {...props} />;
};

export const DialogButtons = (props: DialogActionsProps) => {
  return <DialogActions data-role="dialog-actions" {...props} sx={{ ...(props.sx || {}), pt: 1, px: 3, pb: 3 }} />;
};
